import { lazy } from "react";
import DevicesLoader from "./components/DevicesLoader";
import GpsLoader from "./components/GpsLoader";
import SimcardLoader from "./components/SimcardLoader";
import SimcardDetail from "./components/SimcardDetail/SimcardDetail.container";
import DeviceDetail from "./components/DeviceDetail/DeviceDetail.container";

import { stockSVG, gpsOnSVG, simCardSVG, deviceSvg } from "../shared/helpers/icons";

const EntryPoint = lazy(() => import(/* webpackChunkName: "stock" */ './components/EntryPoint'));

export const defaultPath = "/stock";

export const navigationRoutes = [
    {
        path: `${defaultPath}/gps_devices`,
        Component: GpsLoader,
        exact: true,
        icon: gpsOnSVG,
        title: {
            key: "gps",
            plural: false
        },
        subTitle: {
            key: "list_gps",
            plural: false
        }
    },
    {
        path: `${defaultPath}/devices`,
        Component: DevicesLoader,
        exact: true,
        icon: deviceSvg,
        title: {
            key: "devices",
            plural: false
        },
        subTitle: {
            key: "list_devices",
            plural: false
        }
    },
    {
        path: `${defaultPath}/simcard`,
        Component: SimcardLoader,
        exact: true,
        icon: simCardSVG,
        title: {
            key: "simcards",
            plural: false
        },
        subTitle: {
            key: "list_simcards",
            plural: false
        }
    }
];

// Rutas ocultas (no aparecen en el menú)
export const hiddenRoutes = [
    {
        path: `${defaultPath}/devices/:imei`,
        Component: DeviceDetail,
        exact: true,
        icon: deviceSvg,
        title: {
            key: "devices",
            plural: false
        },
        subTitle: {
            key: "device_detail",
            plural: false
        }
    },
    {
        path: `${defaultPath}/gps/new`,
        Component: lazy(() => import('./pages/Gps/FormGps')),
        exact: true,
        icon: gpsOnSVG,
        title: {
            key: "Agregar GPSs",
            plural: false
        },
        subTitle: {
            key: "",
            plural: false
        }
    },
    {
        path: `${defaultPath}/gps/:name`,
        Component: lazy(() => import('./pages/GpsDetails')),
        exact: true,
        icon: gpsOnSVG,
        title: {
            key: "GPS Details",
            plural: false
        },
        subTitle: {
            key: "",
            plural: false
        }
    },
    {
        path: `${defaultPath}/simcard/:iccid`,
        Component: SimcardDetail,
        exact: true,
        icon: simCardSVG,
        title: {
            key: "simcards",
            plural: false
        },
        subTitle: {
            key: "simcard_detail",
            plural: false
        }
    }
];

// Todas las rutas combinadas para el enrutamiento
export const innerRoutes = [...navigationRoutes, ...hiddenRoutes];

const Stock = {
    path: defaultPath,
    Component: EntryPoint,
    exact: false,
    icon: stockSVG,
    title: {
        key: "stock",
        plural: false
    },
    subTitle: {
        key: " ",
        plural: false
    },
    availableSubMenu: true,
    innerRoutes: navigationRoutes,
    pathChilds: navigationRoutes.map(e => e.path)

};

export default Stock;
